import { createFileRoute } from "@tanstack/react-router";
import { preloadBuildRoute } from "~/features/direct-index-builder/build-route";
import { createPublicBrowseHead } from "~/lib/ssr/public-browse-head";
import { BUILD_SOCIAL_METADATA } from "~/lib/social-metadata";
import { isServerRendering } from "~/lib/ssr/runtime";

export const Route = createFileRoute("/_app/build")({
  ssr: true,
  loader: ({ context }) => {
    const warm = preloadBuildRoute(context);
    if (isServerRendering()) return warm;
    // Navigation can adopt an in-flight intent preload, so every browser load
    // must let the chooser paint while Query fills its catalog.
    void warm;
  },
  head: () => createPublicBrowseHead("/build", BUILD_SOCIAL_METADATA),
});
